import { render } from "./DrawOneFromDiscardIcon.vue?vue&type=template&id=2641c0a4"
import script from "./DrawOneFromDiscardIcon.vue?vue&type=script&lang=js"
export * from "./DrawOneFromDiscardIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__